export default __webpack_public_path__ + "static/media/rejectedCommentIcon.5608e09c.svg";